import { render } from "./AppInputTag.vue?vue&type=template&id=36d9a736&scoped=true"
import script from "./AppInputTag.vue?vue&type=script&lang=js"
export * from "./AppInputTag.vue?vue&type=script&lang=js"

import "@/Common/Styles/appInputTag.scss?vue&type=style&index=0&id=36d9a736&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d9a736"]])

export default __exports__